import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ModuleStructure } from 'src/app/models/module-structure';
import * as Handlebars from 'handlebars';
import { LayoutService } from '../layout.service';

import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { Board } from './models/board.model';
import { Column } from './models/column.model';
import { SectionTableFilter } from 'src/app/models/section-table-filter';

@Component({
  selector: 'app-records-list-kanban',
  templateUrl: './records-list-kanban.component.html',
  styleUrls: ['./records-list-kanban.component.less'],
})
export class RecordsListKanbanComponent implements OnInit {
  @Input() moduleStructure: ModuleStructure;
  @Input() listOfRecords: any;
  @Input() isLoading = true;
  @Input() selectedRecords: string[] = [];
  @Input() pageSize: number;
  @Output() selectRecord = new EventEmitter<any>();

  @Input() customActions: { label: string; key: string }[];
  @Output() customActionClicked = new EventEmitter<{
    key: string;
    value: any;
  }>();

  filters: { [key: string]: SectionTableFilter };
  cardsInfo: any[];

  board: Board = new Board('Test Board', []);

  kanColn: any;
  pageSizeArray: number[] = [];

  constructor(private layoutService: LayoutService) {}

  ngOnInit(): void {
    let index = 0;
    while (index < this.pageSize) {
      this.pageSizeArray.push(index);
      index++;
    }

    this.layoutService
      .executeQuery(
        this.moduleStructure.module.AdditionalInformationParsed
          .KanbanBoardsQueryId,
        []
      )
      .subscribe((kanColns: any[]) => {
        this.filters = {};
        this.kanColn = kanColns;
        kanColns.forEach((colons) => {
          this.getColonCards(colons);
        });

        this.board.columns = this.kanColn;
        console.log('this.board', this.board);
      });
  }

  getRecordHtml(record) {
    const template = Handlebars.compile(
      this.moduleStructure.module.AdditionalInformationParsed.ListTemplate
    );
    const html = template(record);
    return html;
  }

  drop(event: CdkDragDrop<object[]>) {
    console.log(event);
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      console.log(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      console.log(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
  }

  getColonCards(colon: any) {
    this.filters.StepLast = {
      singleValue: colon.Name,
      filterType: 3,
      valueFrom: null,
      valueTo: null,
    };

    this.layoutService
      .getListOfRecords(54,0, 1, 25, 'OpprId', 'DESC', '', 0, [], this.filters, false)
      .subscribe((x: any) => {
        colon.Cards = x.table.rowsArray;
      });
  }
}
